import _toConsumableArray from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
/**
 * Class in charge of managing the clusters and sites in the map
 * @class Cluster
 * @constructor
 * @param {Object} cluster: The cluster object
 * @param {string} _index: key to identify cluster
 */
var Cluster = /*#__PURE__*/_createClass(function Cluster(_cluster, _index) {
  var _this = this;
  _classCallCheck(this, Cluster);
  _defineProperty(this, "parent", null);
  _defineProperty(this, "getClosestChild", function (center) {
    var closestChild = _this.children.reduce(function (acc, location) {
      var distance = getDistance(center, location.getCoor());
      if (distance < acc.distance) {
        return {
          location: location,
          distance: distance
        };
      }
      return acc;
    }, {
      location: _this.children[0],
      distance: Infinity
    }).location;
    if (closestChild.isCluster()) {
      return closestChild.getClosestSitesFromCenter(center);
    }
    return closestChild;
  });
  _defineProperty(this, "add", function (child) {
    _this.children.push(child);
    child.setParent(_this);
  });
  _defineProperty(this, "setParent", function (parent) {
    _this.parent = parent;
  });
  _defineProperty(this, "getParent", function () {
    return _this.parent;
  });
  _defineProperty(this, "getIndex", function () {
    return _this.index;
  });
  _defineProperty(this, "isCluster", function () {
    return true;
  });
  _defineProperty(this, "getCoor", function () {
    return {
      lat: _this.lat,
      lng: _this.lng
    };
  });
  _defineProperty(this, "getClosestSitesFromCenter", function (center) {
    return _this.getClosestChild(center);
  });
  _defineProperty(this, "getChilds", function () {
    return _this.children;
  });
  _defineProperty(this, "getChildByIndex", function (searchIndex) {
    var digit = parseInt(searchIndex[0]);
    if (searchIndex.length === 1) {
      return _this.children[digit];
    }
    if (!_this.children[digit].isCluster()) {
      return _this.children[digit];
    }
    var restIndex = searchIndex.slice(1);
    return _this.children[digit].getChildByIndex(restIndex);
  });
  _defineProperty(this, "getIterativeClosestSite", function (closeSitesRead) {
    var closestChild = _this.children.filter(function (location) {
      return !closeSitesRead.isInList(location.getIndex());
    }).reduce(function (acc, location) {
      var distance = getDistance(closeSitesRead.getCenter(), location.getCoor());
      if (distance > acc.distance) {
        return acc;
      }
      return {
        location: location,
        distance: distance
      };
    }, {
      location: _this.children[0],
      distance: Infinity
    });
    if (closestChild.distance === Infinity) {
      var _this$parent;
      closeSitesRead.addNewIndexInList(_this.getIndex());
      return (_this$parent = _this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.getIterativeClosestSite(closeSitesRead);
    }
    if (closestChild.location.isCluster()) {
      return closestChild.location.getIterativeClosestSite(closeSitesRead);
    }
    closeSitesRead.addNewIndexInList(closestChild.location.getIndex());
    return closestChild.location;
  });
  _defineProperty(this, "getOrderedSitesFromCenter", function (closeSitesRead) {
    var orderedSites = _this.getIterativeClosestSite(closeSitesRead);
    return (orderedSites === null || orderedSites === void 0 ? void 0 : orderedSites.getSitesOrderedByCenter(closeSitesRead.getCenter())) || [];
  });
  _defineProperty(this, "getThreeClustersOrdered", function (closeSitesRead) {
    var oneOrderedSites = _this.getIterativeClosestSite(closeSitesRead);
    var twoOrderedSites = _this.getIterativeClosestSite(closeSitesRead);
    var threeOrderedSites = _this.getIterativeClosestSite(closeSitesRead);
    var totalOrderedSites = [].concat(_toConsumableArray(oneOrderedSites.getSites()), _toConsumableArray(twoOrderedSites.getSites()), _toConsumableArray(threeOrderedSites.getSites()));
    var center = closeSitesRead.getCenter();
    return totalOrderedSites.sort(function (a, b) {
      return getDistance(center, a) - getDistance(center, b);
    });
  });
  _defineProperty(this, "getOrderedSitesFromClusterIndexAndCenter", function (clusterIndex, closeSitesRead) {
    var cluster = _this.getChildByIndex(clusterIndex);
    closeSitesRead.addNewIndexInList(cluster.getIndex());
    return cluster.getSitesOrderedByCenter(closeSitesRead.getCenter());
  });
  this.lat = _cluster.lat;
  this.lng = _cluster.lng;
  this.index = _index;
  this.children = [];
}

/**
 * Method to get the closest child given a center location
 * @param {Object} center: {lat, lng}
 */

/**
 * Method to add a child to the cluster
 * @param {Object} child: The child to add
 */

/**
 * Method to set the parent of the cluster
 * @param {Object} parent: The parent to set
 */

/**
 * Method to get a cluster given an index
 * @param {string} searchIndex: The index to search
 * @returns {Object} The cluster found
 */

/**
 * Method to get the closest sites from the center
 * @param {Object} center: {lat, lng}
 * @returns {Array} The ordered sites
 */

/**
 * Method to get the three closest clusters ordered
 * @param {CloseSites} closeSitesRead: The object to keep track of the sites already read
 */

/**
 * Method to get the ordered sites from a cluster index and center
 * @param {string} clusterIndex: The index of the cluster
 * @param {CloseSites} closeSitesRead: The object to keep track of the sites already read
 */);
/**
 * Class in charge of managing the sites in the map
 * @class ClusterSites
 * @constructor
 * @param {Object} cluster: The cluster object
 * @param {string} _index: key to identify cluster
 * @param {Array} _sites: The sites in the cluster
 */
var ClusterSites = /*#__PURE__*/_createClass(function ClusterSites(cluster, _index, _sites) {
  var _this2 = this;
  _classCallCheck(this, ClusterSites);
  _defineProperty(this, "parent", null);
  _defineProperty(this, "getIndex", function () {
    return _this2.index;
  });
  _defineProperty(this, "setParent", function (parent) {
    _this2.parent = parent;
  });
  _defineProperty(this, "getParent", function () {
    return _this2.parent;
  });
  _defineProperty(this, "isCluster", function () {
    return false;
  });
  _defineProperty(this, "getCoor", function () {
    return {
      lat: _this2.lat,
      lng: _this2.lng
    };
  });
  _defineProperty(this, "getSites", function () {
    return _this2.sites;
  });
  _defineProperty(this, "getSitesOrderedByCenter", function (center) {
    return _this2.sites.sort(function (a, b) {
      return getDistance(center, a) - getDistance(center, b);
    });
  });
  this.lat = cluster.lat;
  this.lng = cluster.lng;
  this.index = _index;
  this.sites = _sites;
}

/**
 * Method to get the closest sites from the center
 * @param {Object} center 
 * @returns Ordered sites
 */);

var getDistance = function getDistance(center, location) {
  return Math.pow(location.lat - center.lat, 2) + Math.pow(location.lng - center.lng, 2);
};

/**
 * Method to initialize the clusters
 * @param {Array} clusters: The clusters to initialize
 * @param {Array} sites: The sites to initialize
 * @returns {Cluster} The initial cluster
 */
export var initClusters = function initClusters(clusters, sites) {
  var mapClusters = function mapClusters(clusterParent, cluster) {
    cluster === null || cluster === void 0 ? void 0 : cluster.forEach(function (clusterChild, index) {
      var completeIndex = "".concat(clusterParent.getIndex()).concat(index);
      if (!clusterChild.sites) {
        var newCluster = new Cluster(clusterChild, completeIndex);
        mapClusters(newCluster, clusterChild === null || clusterChild === void 0 ? void 0 : clusterChild.g, completeIndex);
        clusterParent.add(newCluster);
        return;
      }
      var sitesFromCluster = clusterChild.sites.map(function (yextId) {
        return sites.find(function (site) {
          return site.yId === yextId;
        });
      });
      clusterParent.add(new ClusterSites(clusterChild, completeIndex, sitesFromCluster));
      return;
    });
  };
  var initialCluster = new Cluster({
    lat: 0,
    lng: 0
  }, '');
  mapClusters(initialCluster, clusters);
  return initialCluster;
};

/**
 * Class in charge to save all studies centers and clusters
 * @class CloseSites
 */
export var CloseSites = /*#__PURE__*/function () {
  function CloseSites(lat, lng) {
    _classCallCheck(this, CloseSites);
    _defineProperty(this, "center", {
      lat: 0.0,
      lng: 0.0
    });
    _defineProperty(this, "listStudied", []);
    this.center = {
      lat: lat,
      lng: lng
    };
  }
  _createClass(CloseSites, [{
    key: "isInList",
    value: function isInList(index) {
      return this.listStudied.includes(index);
    }
  }, {
    key: "addNewIndexInList",
    value: function addNewIndexInList(index) {
      this.listStudied.push(index);
    }
  }, {
    key: "getCenter",
    value: function getCenter() {
      return this.center;
    }
  }]);
  return CloseSites;
}();